import { documentReducer, contactReducer, CONTACT_REDUCER_KEY } from '@tempus/t-shared/ui';

import { reducer as documentEdit } from './documentEdit';
import { reducer as notification } from './notification';
import { reducer as patientTrackerV3 } from './patientTrackerV3';
import { reducer as site } from './site';
import { reducer as timeScreening } from './timeScreening';
import { reducer as trial } from './trial';
import { reducer as trialSearch } from './trialSearch';
import { reducer as user } from './user';

export default {
  document: documentReducer,
  documentEdit,
  notification,
  patientTrackerV3,
  site,
  timeScreening,
  trial,
  trialSearch,
  user,
  [CONTACT_REDUCER_KEY]: contactReducer,
};
